import PropTypes from 'prop-types'
import { Controller, useFormContext } from 'react-hook-form'
import { Typography, FormLabelStyled, FormTextStyled } from '../styled'
import { RatingRow, RatingButton } from './fieldStyled'

const SCALE = [1, 2, 3, 4, 5]

export default function RatingInput({ name, label, required }) {
  const { control } = useFormContext()
  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState }) => (
        <div className="mb-3">
          <FormLabelStyled>
            <Typography size="12px">
              {label}
              {required && <span className="text-danger">*</span>}
            </Typography>
          </FormLabelStyled>
          <RatingRow>
            {SCALE.map((value) => (
              <RatingButton
                key={value}
                type="button"
                active={Number(field.value) === value}
                onClick={() => field.onChange(value)}
              >
                {value}
              </RatingButton>
            ))}
          </RatingRow>
          {fieldState.error && (
            <FormTextStyled isError>{fieldState.error.message}</FormTextStyled>
          )}
        </div>
      )}
    />
  )
}

RatingInput.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  required: PropTypes.bool,
}
